import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  menuOpenSelector,
  modeSelector,
  profileDetailsSelector,
} from "../store/selectors/app.selector";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";

import { ReactComponent as PendingAuthorizationIcon } from "../assests/navigation/Pending_Authorization_Icon.svg";
import { ReactComponent as OtherServiceIcon } from "../assests/navigation/Other_Services_Icon.svg";
import { ReactComponent as HistoryIcon } from "../assests/navigation/History_Icon.svg";
import { ReactComponent as BulkUploadIcon } from "../assests/navigation/bulk_payment_upload.svg";
import { KYC_UpdateIcon } from "../assests/navigation/kyc_update_icon";
import { ReactComponent as ServiceRequestIcon } from "../assests/navigation/Service_Request_Icon.svg";
import { ReactComponent as ExchangeRatesIcon } from "../assests/navigation/exchange_rates.svg";

import { useTranslation } from "react-i18next";
import { setMenuOpen, setQuickSearch } from "../store/actions/app.action";
import { Drawer } from "antd";
import FEATURE_CONFIG from "client/feature.config.json";
import { SET_QUICK_SEARCH } from "../store/constants";
import PerfectScrollbar from "react-perfect-scrollbar";

import { ReactComponent as AccountsIcon } from "../assests/new-icons/accounts.svg";
import { ReactComponent as PortfolioIcon } from "../assests/new-icons/portfolio.svg";
import { ReactComponent as TransferIcon } from "../assests/new-icons/transfer.svg";
import { ReactComponent as PaymentsIcon } from "../assests/new-icons/payments.svg";
import { ReactComponent as StatementAnalyzerIcon } from "../assests/new-icons/statement_analyzer.svg";
import { ReactComponent as TradeFinanceIcon } from "../assests/new-icons/tradeFinance.svg";
import { ReactComponent as GEPGIcon } from "../assests/new-icons/gepg.svg";
import { ReactComponent as MobileMoneyIcon } from "../assests/new-icons/pesalink.svg";
import { ReactComponent as MPesaIcon } from "../assests/new-icons/mpesa.svg";
import { ReactComponent as CardManagementIcon } from "../assests/new-icons/card_management.svg";
import { ReactComponent as SalaryAdvanceIcon } from "../assests/new-icons/salary_advance.svg";
import { ReactComponent as ServicerequestIcon } from "../assests/new-icons/other_services.svg";
import { ReactComponent as KYCUpdateIcon } from "../assests/navigation/KYC_Icon.svg";
import { ReactComponent as DashboardIcon } from "../assests/new-icons/dashboard.svg";
import { CONFIG } from "../environment";
import { ReactComponent as TransactionHistoryIcon } from "../assests/navigation/Transaction_History.svg";
import { ReactComponent as BulkPaymentIcon } from "../assests/navigation/bulk_payment.svg";
import { ReactComponent as SalaryUploadIcon } from "../assests/navigation/salary_upload.svg";

export default function SideBar() {
  const mode = useSelector(modeSelector);
  const profileDetails = useSelector(profileDetailsSelector);
  const { t } = useTranslation();
  const menuOpen = useSelector(menuOpenSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log(profileDetails);

  function menuOptions() {
    return (
      <>
        <NavLink
          to={"/dashboard"}
          onClick={() => dispatch(setQuickSearch(undefined))}
        >
          <DashboardIcon />
          <span>
            {t("navigation.home", {
              defaultValue: "Home",
            })}
          </span>
        </NavLink>
        <NavLink
          to={"/portfolio"}
          onClick={() =>
            dispatch({ type: SET_QUICK_SEARCH, payload: undefined })
          }
        >
          <PortfolioIcon />
          <span>
            {t("navigation.portfolio", {
              defaultValue: "Portfolio",
            })}
          </span>
        </NavLink>
        <NavLink
          to={"/accounts"}
          onClick={() => dispatch(setQuickSearch(undefined))}
        >
          <AccountsIcon />
          {t("navigation.account", {
            defaultValue: "Accounts",
          })}
        </NavLink>
        {["I", "AA"].indexOf(mode) > -1 && (
          <>
            <NavLink
              to={"/transfer"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <TransferIcon />
              <span>
                {t("navigation.transfer", {
                  defaultValue: "Transfers",
                })}
              </span>
            </NavLink>
            {FEATURE_CONFIG.SIDEBAR.PAYMENTS && (
             <NavLink
              to={"/payment"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <PaymentsIcon />
              <span>
                {t("navigation.payments", {
                  defaultValue: "Payments",
                })}
              </span>
            </NavLink>
            )}

            {/* {profileDetails["retail"] === true && (
            <NavLink to={"/deposits"}>
              <DepositIcon />
              <span>
                {t("navigation.deposit", {
                  defaultValue: "Deposits",
                })}
              </span>
            </NavLink>
          )} */}

            {/* {profileDetails["retail"] === true && (
            <NavLink to={"/loans"}>
              <LoansIcon />
              <span>
                {t("pages.my_accounts.common_my_accounts.loans", {
                defaultValue: "Loans",
              })}
              </span>
            </NavLink>
          )} */}

           {["I", "AA"].indexOf(mode) > -1 && (
          <NavLink to={"/mobile-money"} id="mobile-money-btn">
            <MobileMoneyIcon />
            <span>
              {t("navigation.mobile_money_transfer", {
                defaultValue: "Mobile Money Transfer",
              })}
            </span>
          </NavLink>
        )}

            {profileDetails["retail"] === true && (
              <NavLink
                to={CONFIG.EXCHANGE_RATE_COMING_SOON ? "/exchange-rate-feature" : "/exchange-rate"}
                onClick={() => dispatch(setQuickSearch(undefined))}
              >
                <ExchangeRatesIcon />
                <span>
                  {t("navigation.exchange_rate", {
                    defaultValue: "Exchange Rates",
                  })}
                </span>
              </NavLink>
            )}

             {profileDetails["retail"] === false && FEATURE_CONFIG.SIDEBAR.SALARY_UPLOAD && (
            <NavLink to={"/salary-upload"}>
              <SalaryUploadIcon />
              <span>{t("navigation.salary_upload", {
                defaultValue: "Salary Upload",
              })}</span>
            </NavLink>
          )}

          {FEATURE_CONFIG.SIDEBAR.BULK_PAYMENT_UPLOAD && (
            <NavLink to={"/bulk-payment-upload"}>
              <BulkUploadIcon />
              <span>Bulk Payment Upload</span>
            </NavLink>
          )}

          {FEATURE_CONFIG.SIDEBAR.BULK_PAYMENT && (
            <NavLink to={"/bulk-payment"}>
              <BulkPaymentIcon />
              <span>Bulk Payment</span>
            </NavLink>
          )}

            {/* <NavLink to={"/my-cheques"}>
            <SalaryUploadIcon/>
            <span>My Cheques</span>
          </NavLink> */}

            {/* <NavLink
              to={"/statement-analyzer"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <StatementAnalyzerIcon />
              <span>Statement Analyzer</span>
            </NavLink> */}

            {/* {profileDetails["retail"] === false && (
              <NavLink
                to={"/trade-finance"}
                onClick={() => dispatch(setQuickSearch(undefined))}
              >
                <TradeFinanceIcon />
                <span>
                  {t("navigation.trade_finance", {
                    defaultValue: "Trade Finance",
                  })}
                </span>
              </NavLink>
            )} */}

            {/* <NavLink
              to={"/government-payment"}
              className=""
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <GEPGIcon />
              <span>
                {t("navigation.gepg", {
                  defaultValue: "GePG",
                })}
              </span>
            </NavLink> */}

            {/* <NavLink
              to={"/pesaLink"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <SalaryAdvanceIcon />
              <span>
                {t("navigation.pesaLink", {
                  defaultValue: "Pesalink",
                })}
              </span>
            </NavLink> */}
            {/* <NavLink
              onClick={() => dispatch(setQuickSearch(undefined))}
              to="/bill-payment/billers"
              state={{ categoryId: "MPESA", categoryName: "MPESA" }}
            >
              <MPesaIcon />
              <span>
                {t("navigation.mpesa", {
                  defaultValue: "Mpesa",
                })}
              </span>
            </NavLink> */}
            {/* <NavLink to={"/card-management"}>
            <CardManagementIcon />
            <span>Card Management</span>
          </NavLink> */}
            {/* {profileDetails["retail"] === true &&
              FEATURE_CONFIG.DASHBOARD.CARD_SETTINGS && (
                <NavLink
                  to={"/card-settings"}
                  onClick={() => dispatch(setQuickSearch(undefined))}
                >
                  <CardManagementIcon />
                  <span>Card Management</span>
                </NavLink>
              )} */}
            {/* {profileDetails["retail"] === true &&
              FEATURE_CONFIG.DASHBOARD.SALARY_ADVANCe && (
                <NavLink
                  to={"/salaray-advance"}
                  onClick={() => dispatch(setQuickSearch(undefined))}
                >
                  <SalaryInAdvanceIcon />
                  <span> Salary Advance</span>
                </NavLink>
              )} */}
          </>
        )}

        {["I", "A", "VR", "VW"].indexOf(mode) > -1 && (
          <>
            <NavLink
              to={"/pending-authorization"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <PendingAuthorizationIcon />
              <span>
                {t("navigation.approval", {
                  defaultValue: "Approval",
                })}
              </span>
            </NavLink>

            <NavLink
              to={"/history"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <HistoryIcon />
              <span>
                {t("navigation.history", {
                  defaultValue: "History",
                })}
              </span>
            </NavLink>
          </>
        )}

        {["I", "AA"].indexOf(mode) > -1 && (
          <>
          {FEATURE_CONFIG.SIDEBAR.SERVICE_REQUEST && (
            <NavLink
              to={"/request"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <ServiceRequestIcon />
              <span>
                {t("navigation.service_request", {
                  defaultValue: "Service Request",
                })}
              </span>
            </NavLink>
          )}

            {/* <NavLink
              to={"/kyc-update"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <KYCUpdateIcon />
              <span>KYC Update</span>
            </NavLink> */}

            <NavLink
              to={"/settings"}
              onClick={() => dispatch(setQuickSearch(undefined))}
            >
              <OtherServiceIcon />
              <span>
                {t("navigation.other", {
                  defaultValue: "Other Services",
                })}
              </span>
            </NavLink>
          </>
        )}
        {["A", "VW"].indexOf(mode) > -1 && (
          <NavLink
            to={"/trans-history"}
            onClick={() => dispatch(setQuickSearch(undefined))}
          >
            <TransactionHistoryIcon />
            <span>
              {t("pages.fundtransfer.transaction_history", {
                defaultValue: "Transaction History",
              })}
            </span>
          </NavLink>
        )}
      </>
    );
  }

  return (
    <>
      <div>
        <div className="side-bar-logo">
          <img
            className="d-none d-lg-block"
            height={35}
            style={{
              cursor: "pointer",
            }}
            src={BANK_LOGO}
            alt="Bank Logo"
            onClick={() => navigate("/dashboard")}
          />
        </div>
        <div className="menu-items">
          <PerfectScrollbar>{menuOptions()}</PerfectScrollbar>
        </div>
      </div>

      <Drawer
        title=""
        placement={"left"}
        closable={false}
        maskClosable={true}
        width={250}
        onClose={() => dispatch(setMenuOpen(false))}
        open={menuOpen}
        key={"left"}
      >
        <div className="my-4" align="center">
          <img
            height={20}
            style={{
              cursor: "pointer",
            }}
            src={BANK_LOGO}
            alt="Bank Logo"
            onClick={() => navigate("/dashboard")}
          />
        </div>
        <div
          className="mobile-menu-options"
          onClick={() => dispatch(setMenuOpen(false))}
        >
          {menuOptions()}

          <NavLink
            to={"/myActivity"}
            onClick={() => dispatch(setQuickSearch(undefined))}
          >
            <OtherServiceIcon />
            <span>
              {" "}
              {t("navigation.my_activity", {
                defaultValue: "My Activity",
              })}
            </span>
          </NavLink>
          <NavLink
            to={"/help"}
            onClick={() => dispatch(setQuickSearch(undefined))}
          >
            <OtherServiceIcon />
            <span>
              {t("navigation.contact", {
                defaultValue: "Contact Us",
              })}
            </span>
          </NavLink>
        </div>
      </Drawer>
    </>
  );
}
